// `project_managers[].role` is the internal team-role label
// (`get_role_display()` — "GCC Admin", "Sales Manager", "Team Member", ...).
// A customer doesn't recognize those; map to a public-facing title where
// one is obvious, and fall back to a generic "Project contact" rather than
// leaking the internal label when a role has no natural customer-facing
// equivalent.
const FRIENDLY_ROLE_LABELS: Record<string, string> = {
  "GCC Admin": "General Contractor",
  "Sales Manager": "Sales Representative",
  "Sales PM": "Project Manager",
  "Project Manager": "Project Manager",
  "Lead PM": "Project Manager",
  "Team Member": "Project Team"
}

export const friendlyContactRole = (role: string | null | undefined): string =>
  (role && FRIENDLY_ROLE_LABELS[role]) || "Project contact"
